<template>
  <div class="d-flex flex-row g-1">
    <v-chip small color="secondary">
      {{ `${$t('status')}: ${$t(status)}` }}
    </v-chip>
    <v-chip small color="info">
      {{ `${$t('date')}: ${date}` }}
    </v-chip>
  </div>
</template>
<script>
export default {
  props: {
    status: {
      required: true,
      type: [String, Number]
    },
    date: {
      required: true,
      type: String
    }
  }
}
</script>
